import React from 'react';
import { connect } from 'react-redux';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as groupsApi from '../../../services/api/groupApi';
import PropTypes from 'prop-types';

const boxTarget = {
  drop(props, monitor, component) {
    if (props.connection.status.online) {
      const hasDroppedOnChild = monitor.didDrop();
      const { student } = monitor.getItem();
      props.classroomGroupActions.assignStudentToGroup(student._id, props.group.id, props.classroom);
      component.setState({
        hasDropped: true,
        hasDroppedOnChild: hasDroppedOnChild
      });
    }
  }
};

class StudentGroup extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.state = {
      hasDropped: false,
      hasDroppedOnChild: false
    };
  }

  static propTypes = {
    group: PropTypes.object,
    isOver: PropTypes.bool,
    connectDropTarget: PropTypes.any,
    colors: PropTypes.object
  };

  renderTotalParticipants() {
    const { group } = this.props;

    return <div className="number">{group.participants ? group.participants.length : 0}</div>;
  }

  render() {
    const { group, isOver, connectDropTarget, colors } = this.props;

    let overBlockDisplay = {
      display: isOver ? 'block' : 'none',
      borderColor: colors[`group0${group.colour}`]
    };
    let groupStyle = {
      border: isOver ? 'none' : 'solid',
      color: colors[`group0${group.colour}`],
      borderColor: colors[`group0${group.colour}`]
    };

    return connectDropTarget(
      <div id={group.id} className={'group-item-container'} data-cy="groupCard">
        <div className={'group-item'} style={groupStyle}>
          {this.renderTotalParticipants()}
          <div className="group-name">{groupsApi.getGroupName(group)}</div>
        </div>
        <div className="over-group" style={overBlockDisplay} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    connection: state.connection,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    dispatch
  };
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true })
  };
}

const DropTargetStudentGroup = DropTarget('studentCard', boxTarget, collect)(StudentGroup);

export default connect(mapStateToProps, mapDispatchToProps)(DropTargetStudentGroup);
